import { render, staticRenderFns } from "./HeaderControlsSocial.vue?vue&type=template&id=211f992c&scoped=true&"
import script from "./HeaderControlsSocial.vue?vue&type=script&lang=js&"
export * from "./HeaderControlsSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211f992c",
  null
  
)

export default component.exports